import { MAX_ZNAKOW_TEKSTU } from "@shared/ocenaTypy.js";
import { dekodujTekstUtf8, KOMUNIKATY_BLEDOW_PARSERA } from "@shared/parserTekstu.js";

/**
 * Plik tekstowy z rozmowa (.txt, UTF-8): sprawdzenie na miejscu i odczyt do podgladu.
 *
 * Formularz czyta plik sam (zeby pokazac "rozpoznano N mowcow, M wypowiedzi" i wiedziec, czy
 * tekst ma podpisy), ale na serwer jedzie oryginalny plik: serwer dekoduje go i parsuje tym samym
 * kodem ze shared/, wiec o wyniku decyduje on, nie podglad.
 */

/**
 * Najwiekszy plik tekstowy w bajtach. LUSTRO src/services/wejscieSesji.ts (MAX_BAJTOW_PLIKU_TEKSTU =
 * 4 bajty na znak najdluzszego tekstu), a nie zrodlo prawdy: klient nie moze go zaimportowac
 * z serwera. Rozstrzyga serwer; ta stala zapobiega tylko wysylaniu pliku, ktory na pewno odpadnie.
 */
export const MAX_BAJTOW_PLIKU_TEKSTU = MAX_ZNAKOW_TEKSTU * 4;

export const POMOC_PLIKU_TEKSTOWEGO = "Plik .txt w kodowaniu UTF-8 - do 400 000 znaków";

/** Plik z rozszerzeniem .txt albo typem text/plain. Word, PDF i reszta odpadaja z podpowiedzia. */
export function walidujPlikTekstowy(plik: { name: string; size: number; type: string }): string | null {
  const nazwaTxt = /\.txt$/i.test(plik.name);
  if (!nazwaTxt && plik.type !== "text/plain") {
    return "To nie jest plik tekstowy. Wybierz plik .txt albo wklej tekst do pola (z dokumentu Worda skopiuj treść i wklej ją tutaj).";
  }
  if (plik.size > MAX_BAJTOW_PLIKU_TEKSTU) return KOMUNIKATY_BLEDOW_PARSERA.TEKST_ZA_DLUGI;
  return null;
}

export type OdczytPliku = { tekst: string } | { blad: string };

/** Odczyt pliku jako UTF-8 w trybie rygorystycznym (plik w starym kodowaniu daje blad, nie krzaczki). */
export function czytajPlikTekstowy(plik: Blob): Promise<OdczytPliku> {
  return new Promise((resolve) => {
    const czytnik = new FileReader();
    czytnik.onerror = () => resolve({ blad: "Nie udało się odczytać pliku. Wybierz go jeszcze raz." });
    czytnik.onload = () => {
      const wynik = czytnik.result;
      // Sprawdzenie po nazwie typu, a nie `instanceof ArrayBuffer`: wynik FileReadera moze pochodzic
      // z innego obszaru JS (ramka, jsdom w testach), a wtedy instanceof zwraca false dla poprawnych danych.
      if (Object.prototype.toString.call(wynik) !== "[object ArrayBuffer]") {
        resolve({ blad: "Nie udało się odczytać pliku. Wybierz go jeszcze raz." });
        return;
      }
      const zdekodowany = dekodujTekstUtf8(new Uint8Array(wynik as ArrayBuffer));
      if ("blad" in zdekodowany) resolve({ blad: KOMUNIKATY_BLEDOW_PARSERA[zdekodowany.blad] });
      else resolve({ tekst: zdekodowany.tekst });
    };
    czytnik.readAsArrayBuffer(plik);
  });
}
